import * as React from 'react'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import { useFormError } from 'modules/timeoff/hooks/useForm'
import type AllowanceIncidenceForm from 'modules/timeoff/lib/AllowanceIncidence'
import { validateLessThanThreeDecimals } from 'modules/timeoff/lib/validateDecimals'

interface Props {
  form: AllowanceIncidenceForm
}

export default function HoursForm({ form }: Props) {
  const setFormError = useFormError()

  const validateDecimals = () => {
    return validateLessThanThreeDecimals(form, setFormError)
  }

  return (
    <>
      <FormRow>
        <Text
          label={i18n.t('time_off.incidences.field_hours')}
          field={form.get('days_in_cents')}
          type="number"
          validation={validateDecimals}
        />
      </FormRow>
    </>
  )
}
